export default __webpack_public_path__ + "static/media/cosomo.a0c37f1d.png";